<template>
  <div>
    <BannerOpacity delay="5000" />
    <div class="content-wrapper">
      <div class="welcome-page-container">
        <WelcomeIcons />
        <BrandsIcons :pageCustom="[[480, 2], [768, 3], [1024, 4]]" :speed="3000" />
        <!-- <ContactForm class="contact-form-welcome-page" /> -->
        <AfterLoginContact class="after-login-contact" />
      </div>
    </div>
  </div>
</template>

<script>
import WelcomeIcons from "./../categories/src/CategoriesIconsWelcome";
import BrandsIcons from "./../brands-carousel/src/BrandCarousel";
import { ContactForm, BannerOpacity } from "../RedbayComponents";
import BeforeLoginContact from "./VetDirectBeforeLoginContact";
import AfterLoginContact from "./AfterLoginContact.vue";

export default {
  name: "WelcomePage",
  data() {
    return {
      list: [{ id: 1, src: "https://picsum.photos/1024/480/?image=52" }]
    };
  },

  components: {
    WelcomeIcons,
    BrandsIcons,
    BannerOpacity,
    ContactForm,
    BeforeLoginContact,
    AfterLoginContact
  },

  beforeMount() {
    if (!this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "mainPage" });
    }
    if (!this.$config.get("welcomePage.enabled")) {
      this.$router.replace({ name: "searchPage" });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/WelcomePage.vue